'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"cover":"loader-module_cover__kKwIc","component-loader__overlay":"loader-module_component-loader__overlay__Q-71d","loader__content":"loader-module_loader__content__vPEbc","small":"loader-module_small__0h0u7","loading":"loader-module_loading__ZCadE","dark":"loader-module_dark__VNdUn","inline-loader":"loader-module_inline-loader__mtJDS","square":"loader-module_square__LiOtw","first":"loader-module_first__jlYg0","last":"loader-module_last__576zt","message":"loader-module_message__x6E6z","preloader":"loader-module_preloader__Rieff","preload":"loader-module_preload__ZdVKX"};

exports.default = styles;
//# sourceMappingURL=loader.module.scss.js.map
